import { TeamEnum } from 'common/enums/TeamEnum';

class TeamUtils {
    static hasNoTeam(teamIds) {
        return teamIds?.includes(TeamEnum.NoTeam);
    }

    static getTeamById(teams, teamId) {
        return teams.find(team => team.teamId === teamId);
    }
}

export default TeamUtils;
